// Müşteri API sarmalayıcısı — ClientPicker işi (2026-10-07). Liste/arama/tekil/facet;
// `includeDeleted` hiç geçilmez (silinmiş kayıt picker'da görünmez).

import type { Client, ClientFacetsResponse, ClientsListResponse } from "@mahir/shared";
import { api } from "./client";
import type { ClientPickerItem } from "../lib/client-picker";

export const CLIENT_SEARCH_LIMIT = 20;

export interface ClientSearchResult {
  items: ClientPickerItem[];
  total: number;
}

export function toPickerItem(
  c: Pick<Client, "id" | "name" | "sector"> & { fiscalYearStartMonth?: number | undefined },
): ClientPickerItem {
  return {
    id: c.id,
    name: c.name,
    sector: c.sector,
    ...(c.sector ? { secondary: c.sector } : {}),
    // M17 T5 — takvim müşterisinde alan yok (öğe byte-eşit)
    ...(c.fiscalYearStartMonth !== undefined && c.fiscalYearStartMonth !== 1
      ? { fiscalYearStartMonth: c.fiscalYearStartMonth }
      : {}),
  };
}

/** `GET /clients?search=&limit=` — ad/sektör/ülke ILIKE, ad sırası. */
export async function searchClients(
  search: string,
  limit = CLIENT_SEARCH_LIMIT,
): Promise<ClientSearchResult> {
  const params = new URLSearchParams();
  const s = search.trim();
  if (s) params.set("search", s);
  params.set("limit", String(limit));
  const res = await api<ClientsListResponse>(`/clients?${params.toString()}`);
  return { items: res.clients.filter((c) => !c.deletedAt).map(toPickerItem), total: res.total };
}

export async function getClientById(id: string): Promise<Client> {
  return (await api<{ client: Client }>(`/clients/${id}`)).client;
}

export async function listClientFacets(): Promise<ClientFacetsResponse> {
  return api<ClientFacetsResponse>("/clients/facets");
}
